/** DESIGN §18: the portal's own errors go to the Worker's logs, nowhere else. */

const MAX_REPORTS = 10;
let sent = 0;
const seen = new Set<string>();

export function reportError(error: unknown): void {
  if (typeof window === "undefined" || typeof fetch !== "function") return;
  const message = error instanceof Error ? `${error.name}: ${error.message}` : String(error);
  const key = message.slice(0, 200);
  if (seen.has(key) || sent >= MAX_REPORTS) return;
  seen.add(key);
  sent += 1;
  const stack = error instanceof Error ? error.stack?.slice(0, 2000) : undefined;
  fetch("/web/api/errors", {
    method: "POST",
    credentials: "same-origin",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ message: message.slice(0, 500), stack, path: window.location.pathname }),
    keepalive: true,
  }).catch(() => {});
}

export function installErrorReporting(): void {
  window.addEventListener("error", (event) => reportError(event.error ?? event.message));
  window.addEventListener("unhandledrejection", (event) => reportError(event.reason));
}
